import resolveResponse from 'contentful-resolve-response'

import {ThemeProvider, Grid} from '@primer/react-brand'

import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'
import {FootnotesProvider} from '@github-ui/swp-core/components/contentful/FootnotesContext'

import {toPayload} from '../../../lib/types/payload'
import {toBrandPage} from '../../../brand/lib/types/contentful'
import type {GenericSectionWithIds} from '../../../brand/lib/types/contentful'

import {FaqSection} from './_sections/FaqSection/FaqSection'
import {FeaturesSection} from './_sections/FeaturesSection/FeaturesSection'
import {HeroSection} from './_sections/HeroSection/HeroSection'
import {PricingSection} from './_sections/PricingSection/PricingSection'
import {ResourcesSection} from './_sections/ResourcesSection/ResourcesSection'

import {PlanTypeContextProvider} from './_context/PlanTypeContext'

export default function FeaturesCopilotIndex() {
  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())
  const contentfulResponse = resolveResponse(contentfulRawJsonResponse)
  const page = toBrandPage(contentfulResponse)

  const {template} = page.fields
  const {subnav} = template.fields
  const {
    featuresCopilotFaqSection,
    featuresCopilotFeaturesSection,
    featuresCopilotHeroSection,
    featuresCopilotPricingSection,
    featuresCopilotResourcesSection,
  } = page.ids as {
    featuresCopilotFaqSection: GenericSectionWithIds
    featuresCopilotFeaturesSection: GenericSectionWithIds
    featuresCopilotHeroSection: GenericSectionWithIds
    featuresCopilotPricingSection: GenericSectionWithIds
    featuresCopilotResourcesSection: GenericSectionWithIds
  }

  return (
    <FootnotesProvider>
      <PlanTypeContextProvider>
        <ThemeProvider colorMode="dark" className="lp-Copilot">
          {featuresCopilotHeroSection ? (
            <HeroSection contentfulContent={featuresCopilotHeroSection} subnav={subnav} />
          ) : null}

          {featuresCopilotFeaturesSection ? (
            <FeaturesSection contentfulContent={featuresCopilotFeaturesSection} />
          ) : null}

          {featuresCopilotPricingSection ? <PricingSection contentfulContent={featuresCopilotPricingSection} /> : null}

          {featuresCopilotResourcesSection ? (
            <ResourcesSection contentfulContent={featuresCopilotResourcesSection} />
          ) : null}

          {featuresCopilotFaqSection ? <FaqSection contentfulContent={featuresCopilotFaqSection} /> : null}

          <Grid>
            <Grid.Column span={12}>
              <ContentfulInlineFootnotesList className="pt-0" />
            </Grid.Column>
          </Grid>
        </ThemeProvider>
      </PlanTypeContextProvider>
    </FootnotesProvider>
  )
}

try{ FeaturesCopilotIndex.displayName ||= 'FeaturesCopilotIndex' } catch {}